module.exports = __webpack_public_path__ + "img/story-title-bg.fe64d07d.png";